import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { useI18n } from "@/i18n/I18nProvider";

/*
 * Both render server-side, so the heading, copy and form markup are still in
 * the HTML — these only split the hydration bundle, matching how the other
 * campaign landing pages import them.
 */
const Campaign = dynamic(() => import("@/components/campaign/Campaign"));
const PageHead = dynamic(() => import("@/components/PageHead"));

export default function CampaignPage() {
  const router = useRouter();
  const { t } = useI18n();

  /*
   * `?t=catalogue` switches the page to the catalogue variant; anything else,
   * a missing param included, falls back to the newsletter one. The lead
   * `source` id is grouped with its variant so the two cannot drift apart.
   */
  const isCatalogue = router.query.t === "catalogue";

  const campaign = isCatalogue
    ? {
        type: "catalogue",
        source: 22,
        title: t.Campaign.catalogueTitle,
        subTitle: t.Campaign.catalogueSubTitle,
      }
    : {
        type: "newsletter",
        source: 23,
        title: t.Campaign.Title1,
        subTitle: t.Campaign.Title2,
      };

  return (
    <>
      <PageHead
        title={t?.pages_main_tags?.campaign?.title}
        description={t?.pages_main_tags?.campaign?.meta_desc}
      />

      <Campaign
        type={campaign.type}
        title={campaign.title}
        subTitle={campaign.subTitle}
        source={campaign.source}
      />
    </>
  );
}
